import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_CARBON_INDICATORS } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const AboveGroundCarbonExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='above-ground-carbon-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.aboveGroundCarbon.explainers.howDoMeasureThis.headline')}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              body={t('shared.ncaDetail.details.aboveGroundCarbon.explainers.howDoMeasureThis.carbonAboveGroundBody')}
            />
            <ExplainerCopy
              body={t('shared.ncaDetail.details.aboveGroundCarbon.explainers.howDoMeasureThis.carbonAboveGroundBody2')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_CARBON_INDICATORS} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
